import { createAction, props } from '@ngrx/store';
import { Alert } from '../../models';

export const LoadAlerts = createAction('[Alert] Load Alerts');
export const LoadAlertsSuccess = createAction('[Alert] Load Alerts Success', props<{ Alert: Alert[] }>());
export const LoadAlertsFail = createAction('[Alert] Load Alerts Fail', props<{ error: any }>());
